<div class="flex flex-col bg-white comic-book py-24 md:py-14">
  <div
    class="title-header md:-top-16 flex flex-wrap min-h-screen background-blue relative border-4 border-black"
  >
    <span class="absolute w-1/4 right-0 h-full halftone top-right"></span>
    <span
      class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
    ></span>

    <div
      class="straighten w-full md:w-1/2 p-4 flex items-center justify-center"
    >
      <div class="p-8 md:.panel-container">
        <h1 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
          >
            Get Involved!
          </span>
        </h1>
        <h3
          class="text-3xl font-semibold tracking-tight select-none mb-2 text-gray-900"
        >
          It's easier than you think.
        </h3>
        <p class="mt-6 text-xl text-blue-100">
          <strong>Share our resources</strong> with those who need them.
          <strong>Lend your skills</strong> to create new content or curate
          existing materials. <strong>Support our mission</strong> financially.
        </p>
        <p class="mt-3 text-xl text-blue-100">
          Every action, no matter how small, ripples outward to create positive
          change. Every action helps all learners have access to the tools and
          localised resources they need to succeed.
        </p>
        <p class="mt-3 text-xl text-blue-100">
          Together, we can build a future where everyone can learn in their own
          language.
        </p>
        <div class="flex items-center justify-start gap-x-6 mt-12"></div>
      </div>
    </div>
    <div class="w-full md:w-1/2 p-4 straighten">
      <div
        class="p-4 max-w-2xl h-full flex flex-col justify-center items-center"
      >
        <div class="bg-yellow-300 mb-2 p-4 w-full">
          <h3 class="text-xl font-medium font-bangers">Support Our Mission</h3>
          <p>
            The quickest and simplest way to support our mission is donating, it
            helps us expand the resources and the platform functionality.
          </p>
          <a
            href="https://ko-fi.com/studyheroes"
            target="_blank"
            class="font-bold btn btn-primary mt-2"
            >Donate on Ko-fi</a
          >
        </div>

        <div class="bg-slate-50 mb-2 p-4 w-full">
          <h3 class="text-xl font-medium font-bangers">
            Share, Invite and Send!
          </h3>
          <p>
            Sharing is caring, inviting and sending resources helps us reach
            more students and teachers who are in need of localised resources.
          </p>
          <app-share
            [buttonText]="'Share'"
            [buttonClasses]="'btn-primary btn-fast mt-3'"
          ></app-share>
        </div>

        <div class="bg-slate-50 mb-2 p-4 w-full">
          <h3 class="text-xl font-medium font-bangers">
            Create and Share Educational Resources
          </h3>
          <p>
            Help build our library of educational resources by creating and
            sharing your own materials. Whether you're a teacher, subject
            expert, or passionate educator, your contributions can make a
            difference.
          </p>
          <a
            href="/resources/create"
            class="mt-3 btn btn-fast btn-primary font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
          >
            Create a Resource
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<svg style="display: none">
  <defs>
    <symbol
      id="create-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </symbol>
  </defs>
</svg>
